export default function getHeightOfMinutes(minutes: number) {
    return (minutes * 960) / 1440;
}
